<style>
@import '../../custom/css/admin-navigation.css';
</style>

<template>
  <div class="profissional">
    <div class="row m-0">
      <div class="col-lg-3 col-md-3 col-sm-12 col-12 p-0 bg-gray-1">
        <div class="menu-area-restrita">
          <Topic :text="'Gerenciar'" :icon="'fas fa-tasks'" />
          <BasicItem
            :text="'Minhas Obras'"
            :icon="'fas fa-archway'"
            :routeName="'journal-constructions'"
          />
          <BasicItem
            :text="'Minhas Equipes'"
            :icon="'fas fa-users'"
            :routeName="'journal-teams'"
          />
          <BasicItem
            :text="'Posts'"
            :icon="'fas fa-comment-alt'"
            :routeName="'journal-posts'"
          />
        </div>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-12 col-12 p-0">
        <div class="conteudo-area-restrita">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Item from '../../components/Menu/Item.vue';
import Topic from '../../components/Menu/Topic.vue';
import BasicItem from '../../components/Menu/BasicItem.vue';

export default {
  name: 'journal',
  components: {
    Item,
    Topic,
    BasicItem,
  },
};
</script>
